"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearAfter = exports.required = exports.passwordScore = exports.password = exports.iata = exports.email = exports.departure = void 0;
var _reactIntl = require("react-intl");
var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));
var _isAfter = require("date-fns/isAfter");
var _addYears = require("date-fns/addYears");
var _js = require("@adeira/js");
var _errors = _interopRequireDefault(require("../../consts/errors"));
const keys = (0, _reactIntl.defineMessages)({
  required: {
    id: "forms.this_field_must_be_filled"
  },
  emailInvalid: {
    id: "booking.passenger.email.invalid"
  },
  common: {
    id: "common.error"
  },
  iata: {
    id: "forms.enter_iata_code"
  }
});
const required = val => val ? null : keys.required;
exports.required = required;
const email = val => (0, _isEmail.default)(val) ? null : keys.emailInvalid;
exports.email = email;
const yearAfter = _ref => {
  let {
    offset = 0,
    now = new Date()
  } = _ref;
  return val => (0, _isAfter.isAfter)(val, (0, _addYears.addYears)(now, offset)) ? null : keys.common;
};
exports.yearAfter = yearAfter;
const iata = val => val.match(/^[A-Za-z]{3}$/) ? null : keys.iata;
exports.iata = iata;
const departure = function (val) {
  let now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return (0, _isAfter.isAfter)(val, (0, _addYears.addYears)(now, -1)) ? null : keys.common;
};
exports.departure = departure;
const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_STRENGTH_LEVEL = 2;
const passwordScore = (value, userInput) => {
  process.env.NODE_ENV !== "production" ? (0, _js.warning)(window.zxcvbn != null, "NITRO(passwordScore): You need to load zxcvbn and store it to window global object") : void 0;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error: add zxcvbn to global window maybe
  const score = window.zxcvbn ? window.zxcvbn(value, userInput).score : 0;
  return score;
};
exports.passwordScore = passwordScore;
const password = value => {
  if (value.length < PASSWORD_MIN_LENGTH) {
    return _errors.default.shortPassword;
  }
  const score = passwordScore(value);
  if (score < PASSWORD_STRENGTH_LEVEL) {
    return _errors.default.weakPassword;
  }
  return null;
};
exports.password = password;